import React, { useState, useEffect, useContext } from 'react';
import { Box, Grid, Paper, Typography, TextField, Checkbox, Table, TableHead, TableRow, TableCell, TableBody, Autocomplete , Radio , FormControlLabel } from '@mui/material';
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';


const OvertimeSignup = () => {
  const { permission , v3Data } = useContext(AuthContext);
  const [overtimeShifts, setOvertimeShift] = useState([])
  const [overtimeHours, setOvertimeHours] = useState([])
  const [loading, setLoading] = useState(true);
  const [selectedShifts, setSelectedShifts] = useState([])
  const [employees, setEmployees] = useState([])
  const [selectedEmp, setSelectedEmp] = useState('')
  const [emptyMessage, setEmptyMessage] = useState('')
  const allowedVars = v3Data;

  const loadHoursData = () => {
    setLoading(true)
    ApiService.get('/getHourShifts')
      .then(({ data }) => {
        setOvertimeHours(data?.data)
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const loadShiftData = () => {
    setLoading(true)
    var body = {}
    if (selectedEmp) {
      body.Emp_Code = selectedEmp
    }
    ApiService.get('/overtimeSignupList', body)
      .then(({ data }) => {
        setOvertimeShift(data?.data)
        var tempArr = []
        data?.data?.map((li) => {
          li.shifts.map((shift) => {
            if (shift.prevAction != null) {
              var tempObj = {
                ShiftDate: li.shiftDate,
                ShiftCode: shift.ShiftCode,
                Value: shift.prevAction,
                is_admin_override_sick_leave : li.is_sick_leave_date
              }
              tempArr.push(tempObj)
            }
          })
        })
        setSelectedShifts(tempArr)
        setLoading(false)
      })
      .catch((e) => {
        setEmptyMessage(e?.response?.data)
        setLoading(false)
      })
  }

  const loadEmployees = () => {
    ApiService.get('/employees-list?search=')
      .then(({ data }) => {
        var tempArr = []
        data.data.map((emp) => {
          var obj = emp
          obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
          tempArr.push(obj)
        })
        setEmployees(tempArr)
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  const selectShift = (date, code, value , isSickLeave) => {
    var tempArr = [...selectedShifts]

    if (tempArr.find((a) => a.ShiftDate == date && a.ShiftCode == code)) {
      if (value == 'FULLTIME') {
        const index = tempArr.findIndex(a => a.ShiftDate == date && a.ShiftCode == code)
        if (tempArr[index].Value == '') {
          tempArr[index].Value = value,
          tempArr[index].is_admin_override_sick_leave = isSickLeave
        }
        else {
          tempArr[index].Value = ''
          tempArr[index].is_admin_override_sick_leave = isSickLeave
        }
      }
			else if (value == 'DECLINE') {
        const index = tempArr.findIndex(a => a.ShiftDate == date && a.ShiftCode == code)
        if (tempArr[index].Value == '') {
          tempArr[index].Value = value,
          tempArr[index].is_admin_override_sick_leave = isSickLeave
        }
        else {
          tempArr[index].Value = ''
          tempArr[index].is_admin_override_sick_leave = isSickLeave
        }
      }
      else {
        var valArr = tempArr.find((a) => a.ShiftDate == date && a.ShiftCode == code)?.Value?.split(',') || [tempArr.find((a) => a.ShiftDate == date && a.ShiftCode == code)?.Value]
        if (valArr.includes(value)) {
          const indx = valArr.indexOf(value)
          valArr.splice(indx, 1)
        }
        else {
          valArr.push(value)
        }
        const index = tempArr.findIndex(a => a.ShiftDate == date && a.ShiftCode == code)
        tempArr.splice(index, 1)
        var tempObj1 = {
          ShiftDate: date,
          ShiftCode: code,
          Value: valArr.toString() || '',
          is_admin_override_sick_leave : isSickLeave
        }
        tempArr.push(tempObj1)
      }
    }
    else {
      var tempObj = {
        ShiftDate: date,
        ShiftCode: code,
        Value: value,
        is_admin_override_sick_leave : isSickLeave
      }
      tempArr.push(tempObj)
    }
    setSelectedShifts(tempArr)
  }

	const select24Shift = (date, shiftLength) => {
	let tempArr = [...selectedShifts];

	const shiftsForDate = tempArr.filter((a) => a.ShiftDate === date);
	if (shiftsForDate.length === shiftLength) {
		if (shiftsForDate.every((a) => a.Value === 'FULLTIME')) {
			tempArr = tempArr.map((item) => {
				if (item.ShiftDate === date) {
					return { ...item, Value: '' };
				}
				return item;
			});
		} else {
			tempArr = tempArr.map((item) => {
				if (item.ShiftDate === date) {
					return { ...item, Value: 'FULLTIME' };
				}
				return item;
			});
		}
	} else {
		tempArr = tempArr.filter((a) => a.ShiftDate !== date);

		tempArr.push(
			{
				ShiftDate: date,
				ShiftCode: 2,
				Value: 'FULLTIME',
			},
			{
				ShiftDate: date,
				ShiftCode: 3,
				Value: 'FULLTIME',
			}
		);
	}
		setSelectedShifts(tempArr);
	};

  const saveData = () => {
    setLoading(true)
    const body = {
      data: selectedShifts
    }
    if (selectedEmp) {
      body.Emp_Code = selectedEmp
    }
    ApiService.post('/saveOvertimeSignup', body).then((data) => {
      toast.success('Overtime signup saved successfully')
      setSelectedShifts([])
      loadHoursData()
      loadShiftData()
    }).catch((error) => {
      setLoading(false)
      toast.error(error?.data?.message)
      //console.log('err', data);
    })
  }

  useEffect(() => {
    loadHoursData()
    loadEmployees()
  }, [])

  useEffect(() => {
    loadShiftData()
  }, [selectedEmp])

	return (
    <>
      <Paper className="p-4" style={{ marginTop: "1rem" }}>
        <div className='mb-4'>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={permission.includes('Emp_Auth') ? 4 : 10}>
              <Typography variant="h5">Overtime Signup Form</Typography>
            </Grid>

            {allowedVars?.V3_BLOCK_OT_ON_SICK_LEAVE && permission.includes('Emp_Auth') &&
              <Grid item xs={12} sm={3} md={3} sx={{ display: 'flex' , marginTop:'10px'}}>
                <Typography>Admin Override Sick Leave</Typography>
                <img src='/images/check1.png' width={'22px'} height={'22px'} className='mx-2'/>
              </Grid>
            } 
            
            {permission && permission.includes('Emp_Auth') &&
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  options={employees}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => setSelectedEmp(newValue?.Emp_Code || "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Employee"
                      variant="outlined"
                      fullWidth
                      size="small"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "48px",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center"
                        }
                      }}
                    />
                  )}
                />
              </Grid>
            }
						<Grid item xs={12} sm={6} md={2} sx={{display:'flex' , justifyContent:'end'}}>
							<ButtonTheme disabled={selectedShifts.length == 0} type='submit' variant="filled" color='primary'
								className='px-5' onClick={saveData}>
								Save
							</ButtonTheme>
            </Grid>
          </Grid>
        </div>

        {overtimeShifts && overtimeShifts?.length > 0 ?
        <Box>
          <Table>
            <TableHead sx={{ backgroundColor: "#F4F4F4" }} >
              <TableRow>
								{Object.keys(allowedVars).includes('V3_OVERTIME_SIGNUP_PRE_DECLINE') ?
									<TableCell className='px-2'>Pre-accept / Pre-decline</TableCell> :
									<TableCell className='px-1'></TableCell> 
								}
                <TableCell className='px-1'>Shift Details</TableCell>
                <TableCell className='px-1' align="left">Group</TableCell>
                <TableCell className='px-1' align="left">Open Positions</TableCell>
							  {allowedVars['V3_Overtime_Signup_Custom_Time_Allow'] &&
									<TableCell className='px-1' align="left">Availability</TableCell>
								}
              </TableRow>
            </TableHead>
            <TableBody>
              {overtimeShifts && overtimeShifts.length > 0 && overtimeShifts.map((li) => (
								<>
								{allowedVars['V3_Overtime_Signup_24_Option_Allow'] && li.shifts.length > 1 &&
									<TableRow>
										<TableCell className='px-1'>
											<Checkbox label={`11/10/2024 Sunday Day`}
												checked={selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.Value == 'FULLTIME').length == li.shifts.length}
												onClick={(e) => select24Shift(li.shiftDate, li.shifts.length)}
											/>
										</TableCell>

										<TableCell className='px-1'>
											<Row style={{ alignItems: 'center', fontSize: 14, color: '#666' }}>
												<Col>
													<span className="w-100">
														{moment(li.shiftDate).format('MM/DD/YYYY, ddd')}
													</span>
													<span
														style={{
															backgroundColor: '#6E7C87',
															color: '#fff',
															fontWeight: '400',
															fontSize: "16px",
															padding: "5px 26px",
														}}
														className='rounded-5 ms-3'
													>
														{24}
													</span>
												</Col>
											</Row>
										</TableCell>

										<TableCell className='px-1'>
											<Row style={{ alignItems: 'center', marginLeft: "0", marginRight: "8px" }}>
												<div className='d-flex align-items-center gap-3 ps-0 pe-5'>
													<span className='d-flex justify-content-center align-items-center' style={{ color: "#BF1D2D", fontSize: "16px", fontWeight: "600", backgroundColor: "#BF1D2D1A", borderRadius: "50%", width: "26px" }}>
														{li.groupName}
													</span>
													<img src='/images/right-arrow-2.svg' />
												</div>
											</Row>
										</TableCell>

										<TableCell className='px-1'>
											<Row style={{ alignItems: 'center', marginLeft: "0" }}>
												<span className='d-flex justify-content-center align-items-center' style={{ color: "#fff", fontSize: "16px", fontWeight: "600", backgroundColor: "#E62719", borderRadius: "50%", width: "26px" }}>
													{li.openShifts}
												</span>
											</Row>
										</TableCell>
										
										<TableCell>

										</TableCell>
									</TableRow >}

                  {li.shifts.map((shift) => (
                    <TableRow>
											{Object.keys(allowedVars).includes('V3_OVERTIME_SIGNUP_PRE_DECLINE') ? 
												<TableCell className='px-2'>
													<label style={{fontSizeL:'14px' , marginRight:'20px'}}>Fulltime :</label>
													<FormControlLabel
														control={
															<Checkbox
																checked={
																	selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.Value == 'FULLTIME').length > 0
																}
																onClick={() => selectShift(li.shiftDate, shift.ShiftCode, 'FULLTIME' , li.is_sick_leave_date)}
																disabled={
																	selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.Value != 'FULLTIME' && a.Value != '').length > 0
																}
															/>
														}
														label="Accept"
														sx={{
															'& .MuiFormControlLabel-label': {
																fontSize: '14px'
															}
														}}
													/>

													<FormControlLabel
														control={
															<Checkbox
																checked={
																	selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.Value == 'DECLINE').length > 0
																}
																onClick={() => selectShift(li.shiftDate, shift.ShiftCode, 'DECLINE' , li.is_sick_leave_date)}
																disabled={
																	selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.Value != 'DECLINE' && a.Value != '').length > 0
																}
															/>
														}
														label="Decline"
														sx={{
															'& .MuiFormControlLabel-label': {
																fontSize: '14px'
															}
														}}
													/>
												</TableCell> 
												: 
												<TableCell className='px-1'>
													<Checkbox label={`11/10/2024 Sunday Day`}
														checked={selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.Value == 'FULLTIME').length > 0}
														onClick={() => selectShift(li.shiftDate, shift.ShiftCode, 'FULLTIME' , li.is_sick_leave_date)}
														disabled={
                              selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.Value != 'FULLTIME' && a.Value != '').length > 0 ||
                              li.is_sick_leave_date && allowedVars?.V3_BLOCK_OT_ON_SICK_LEAVE && !permission.includes('Emp_Auth')
                            }
													/>
												</TableCell>
											}
                      
                      <TableCell className='px-1'>
                       <Row style={{ alignItems: 'center', fontSize: 14 }}>
                          <Col style={{display:'flex', alignItems:'center'}}>
                            <span style={{width:'110px' , paddingTop:'8px'}}>
                              {moment(li.shiftDate).format('MM/DD/YYYY, ddd')}
                            </span>
                            <span
                              style={{
                                backgroundColor: shift.name === "Day" ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
																border: shift.name === "Day" ?  '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)',
                                color: 'rgba(0, 0, 0, 0.87)',
                                fontWeight: '400',
                                fontSize: "14px",
																padding: shift.name === "Day" ? '6px 20px' : '6px 16px',
                                width:'70px'
                              }}
                              className='rounded-5 ms-1'
                            >
                              {shift.name}
                            </span>
 
                            {li.is_sick_leave_date && allowedVars?.V3_BLOCK_OT_ON_SICK_LEAVE &&
                              <span
                                style={{
                                  backgroundColor: '#FFE6E6',
                                  border: '#BF1D2D',
                                  color: '#BF1D2D',
                                  fontWeight: '400',
                                  fontSize: "14px",
                                  padding: '6px 20px',
                                }}
                                className='rounded-5 ms-1'
                              >
                                SL
                              </span>
                            }

                            {allowedVars?.V3_BLOCK_OT_ON_SICK_LEAVE && permission.includes('Emp_Auth') && selectedShifts.filter((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode && a.is_admin_override_sick_leave == true && a.Value !== '').length > 0 &&
                              <img src='/images/check1.png' width={'22px'} height={'22px'} className='mx-2'/>
                            }
               
                          </Col>
                        </Row>
                      </TableCell>

                      <TableCell className='px-1'>
                        <Row style={{ alignItems: 'center', marginLeft: "0", marginRight: "8px" }}>
                          <div className='d-flex align-items-center gap-3 ps-0 pe-5'>
                            <span className='d-flex justify-content-center align-items-center' style={{ color: "#BF1D2D", fontSize: "16px", fontWeight: "600", backgroundColor: "#BF1D2D1A", borderRadius: "50%", width: "26px" }}>
                              {li.groupName}
                            </span>
                            <img src='/images/right-arrow-2.svg' />
                          </div>
                        </Row>
                      </TableCell>

                      <TableCell className='px-1'>
                        <Row style={{ alignItems: 'center', marginLeft: "0" }}>
                          <span className='d-flex justify-content-center align-items-center' style={{ color: "#fff", fontSize: "16px", fontWeight: "600", backgroundColor: "#E62719", borderRadius: "50%", width: "26px" }}>
                            {shift.openShifts}
                          </span>
                        </Row>
                      </TableCell>
											
											{allowedVars['V3_Overtime_Signup_Custom_Time_Allow'] &&
                      <TableCell className='px-1'>
                        <Col>
                          <Row className='w-100 g-0' style={{ alignItems: 'center' }}>
                            <Col md={'auto'} style={{fontSizeL:'14px'}}>Custom :</Col>
                            {overtimeHours[shift?.name?.toUpperCase()].map((hr) => {
                              var checked = false
                              var tempArr = [...selectedShifts]
                              var valArr = tempArr.find((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode)?.Value?.split(',') ||
                                [tempArr.find((a) => a.ShiftDate == li.shiftDate && a.ShiftCode == shift.ShiftCode)?.Value]
                              if (valArr.includes(hr)) {
                                checked = true
                              }
                              return (
                                <Col md={'auto'} className='ps-1'>
                                  <Checkbox label={hr}
                                    checked={checked}
                                    onClick={() => selectShift(li.shiftDate, shift.ShiftCode, hr , li.is_sick_leave_date)}
                                    disabled={
																			selectedShifts.filter(
																				(a) => 
																					a.ShiftDate === li.shiftDate &&
																					a.ShiftCode === shift.ShiftCode &&
																					(a.Value === 'FULLTIME' || a.Value === 'DECLINE')
																			).length > 0 ||
                                      (li.is_sick_leave_date && allowedVars?.V3_BLOCK_OT_ON_SICK_LEAVE && !permission.includes('Emp_Auth'))
																		}
																		sx={{
																			'& .MuiFormControlLabel-label': {
																				fontSize: '14px'
																			}
																		}}
                                  />
                                  {hr}
                                </Col>
                              )
                            })}
                          </Row>
                        </Col>
                      </TableCell>}
                    </TableRow >
                  ))}
                </>
              ))}
            </ TableBody>
          </Table>
          <ButtonTheme disabled={selectedShifts.length == 0} type='submit' variant="filled" color='primary'
            className='px-5 mt-4' onClick={saveData}>
            Save
          </ButtonTheme>
        </Box>
        :
          <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 570 }}>
            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
            <span className='mt-4' style={{ color: '#555555' }}>
              {emptyMessage}
            </span>
          </div>
        }
      </Paper >
    </>
  )
}

export default OvertimeSignup

// const select24Shift = (date, shiftLength) => {
// 	let tempArr = [...selectedShifts];
// 	// console.log(shiftLength,'kkkkkkkkkk')
// 	if (tempArr.filter((a) => a.ShiftDate == date).length == shiftLength) {
// 		if(tempArr.find((a) => a.ShiftDate == date && a.Value == '')){
// 			tempArr.forEach((item) => {
// 				if (item.ShiftDate === date) {
// 					item.Value = 'FULLTIME';
// 				}
// 			});
// 		}
// 		else {
// 			tempArr.forEach((item) => {
// 				if (item.ShiftDate === date) {
// 					item.Value = '';
// 				}
// 			});
// 		}
// 	} 
// 	else {
// 		tempArr = tempArr.filter((a) => a.shiftDate != date)
// 		console.log(tempArr,'lllllllll')
// 		tempArr.push({
// 			ShiftDate: date,
// 			ShiftCode: 2,
// 			Value: 'FULLTIME'
// 		});

// 		tempArr.push({
// 			ShiftDate: date,
// 			ShiftCode: 3,
// 			Value: 'FULLTIME'
// 		});
// 	}
// 	setSelectedShifts(tempArr);
// };